import {HttpClient} from "@angular/common/http";
import {Injectable} from "@angular/core";
import {Observable} from "rxjs";
import * as site from "site";
import {OrgService} from "../shared/org.service";
import {AvdbIssueManifest} from "./avdb-issue-manifest";
import {EnablementUpdateSelection, GarminDatabaseUpdateSelection, JeppesenDatabaseUpdateSelection, UpdateSelection} from "./update-selection";

@Injectable()
export class AvdbUpdateService {
	constructor(
		private http: HttpClient,
		private orgService: OrgService
	) { }

	createBatchUpdate(
			garminDatabases: Array<GarminDatabaseUpdateSelection> = [],
			enablements: Array<EnablementUpdateSelection> = [],
			jeppChartDevices: Array<number> = [],
			agentRequest: boolean = false,
			oemManaged: boolean = false): Observable<string> {


		let updateSelection = new UpdateSelection({
			garminDatabases,
			enablements,
			jeppesenDatabases: new JeppesenDatabaseUpdateSelection({
				jeppChartAuthorizedDeviceIDs: jeppChartDevices,
			}),
		});

		let specialPath = "";
		if (agentRequest) specialPath = "agent/";
		else if (oemManaged) specialPath = "oem/";

		let url = `${site.contextPath}/api/${specialPath}batch-updates/`;
		return this.http.post<any>(url, updateSelection, {headers: this.orgService.contextHttpHeader})
			.map(json => json.launchURL);
	}

	getIssueManifest(seriesID: number, issueName: string): Observable<AvdbIssueManifest> {
		let url = `${site.contextPath}/api/avdb-series/${seriesID}/${encodeURIComponent(issueName)}/files/`;
		return this.http.get<Observable<AvdbIssueManifest>>(url, {headers: this.orgService.contextHttpHeader})
			.map(json => AvdbIssueManifest.fromJSON(json));
	}
}
